import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  TelemetryOrgSettingsToggleProps,
  TelemetryOrgSettingsToggle
} from '../../../components/telemetry/telemetry-org-settings-toggle'

function TelemetryOrgSettingsToggleWrapper({
  onToggle,
  enabled = false
}: TelemetryOrgSettingsToggleProps) {
  if (!onToggle) {
    throw new Error('onToggle is Required')
  }
  return <TelemetryOrgSettingsToggle onToggle={onToggle} enabled={enabled} />
}

export const telemetryOrgSettingsToggle = createNgReactBridgeDirective(
  'reactTelemetryOrgSettingsToggle',
  [],
  TelemetryOrgSettingsToggleWrapper,
  ['onToggle', 'enabled']
)
